module.exports = __webpack_public_path__ + "static/devil_shape2-18965992e49ef33ce855d5d52708728b.png";